//people reducer types
export const LOADING_PEOPLE = "LOADING_PEOPLE";
export const LOAD_PEOPLE = "LOAD_PEOPLE";
export const FETCH_PEOPLE_REQUEST = "FETCH_PEOPLE_REQUEST";
export const FETCH_PEOPLE_REQUEST_SUCCESS = "FETCH_PEOPLE_REQUEST_SUCCESS";
export const PEOPLE_SAVE_REQUEST = "PEOPLE_SAVE_REQUEST";
export const PEOPLE_SAVE_SUCCESS = "PEOPLE_SAVE_SUCCESS";
export const PROFILE_SAVE_REQUEST = "PROFILE_SAVE_REQUEST";
export const PROFILE_SAVE_SUCCESS = "PROFILE_SAVE_SUCCESS";
export const PROFILE_AVATAR_SAVE_SUCCESS = "PROFILE_AVATAR_SAVE_SUCCESS";
export const PROFILE_AVATAR_SAVE_REQUEST = "PROFILE_AVATAR_SAVE_REQUEST";
export const PEOPLE_EMPLOYEE_FACILITIES = "PEOPLE_EMPLOYEE_FACILITIES";
export const FETCH_PEOPLE_ROOT_FACILITY_REQUEST =
  "FETCH_PEOPLE_ROOT_FACILITY_REQUEST";
export const FETCH_PEOPLE_ROOT_FACILITY_REQUEST_SUCCESS =
  "FETCH_PEOPLE_ROOT_FACILITY_REQUEST_SUCCESS";
export const SEND_MAIL = "SEND_MAIL";
export const SEND_MAIL_SUCCESS = "SEND_MAIL_SUCCESS";
export const PROFILE_SAVE_SUCCESS_FAILED = "PROFILE_SAVE_SUCCESS_FAILED";
